<template>
  <OneCol
    :center="true"
    :borderRadius="0"
    :backgroundImage="$store.state.width > 767 ? $store.state.copy.shareAsk.image : $store.state.copy.shareAsk.imageMob"
    extraClass="smaller shareAsk"
    padding="0px"
    maxWidth="100%"
  >
    <template v-slot:title>
      <div class="fit_wrap center">
        <h1>You scored {{ $store.getters.getScore }} out of {{ $store.state.questions.length }}!</h1>
      </div>
    </template>
    <template v-slot:body>
      <div class>
        <GenericButton
          @click="showAnswers = !showAnswers"
          text="See my answers"
          textColor="black"
          fontSize="22px"
          preset="text"
          :style="{marginTop: '30px !important'}"
        ></GenericButton>
      </div>
      <div class="inner_wrap" :class="{ show: showAnswers }">
        <div class="result" v-for="(q, i) in $store.state.questions" :key="i">
          <div
            class="result_head"
            :class="{ wrong: q.userAnswer != q.answer}"
          >{{ i+1 }}: {{ q.userAnswer == q.answer ? 'You were correct' : 'You were incorrect' }}</div>
          <div class="result_body" v-html="q.answerText"></div>
        </div>
      </div>
      <div class="bottom_section">
        <div class="bottom_text" v-html="$store.state.copy.shareAsk.question"></div>

        <div class="button_wrap">
          <GenericButton
            @click="gotoSlide('share'), analytics('shareask', 'yes')"
            :text="$store.state.copy.shareAsk.yes_btn"
            textColor="white"
            minWidth="220px"
          ></GenericButton>
          <GenericButton
            @click="gotoSlide('donate'), analytics('shareask', 'skip'), $store.commit('updateExtraProgress')"
            :text="$store.state.copy.shareAsk.no_btn"
            textColor="white"
            minWidth="220px"
            color="#4A4A4A"
            hoverColor="#686868"
          ></GenericButton>
        </div>
      </div>
    </template>
  </OneCol>
</template>

<script>
import OneCol from "../components/template/OneCol";
import GenericButton from "../components/generic/GenericButton";
export default {
  name: "ShareAsk",
  components: {
    OneCol,
    GenericButton
  },
  data() {
    return {
      showAnswers: false
    };
  }
};
</script>
<style lang="scss">
.shareAsk {
  .top_section {
    background: black;
    color: white;
    padding: 40px;
    @media (max-width: 767px) {
      padding: 20px;
      text-align: left;
    }
  }
  h2 {
    margin-bottom: 0;
    &.green {
      color: #62ce00;
    }
  }
  p {
    font-size: 18px;
    line-height: 1.44;
    text-align: center;
    &:last-of-type {
      margin-bottom: 0;
    }

    &.green {
      color: #62ce00;
    }
    @media (max-width: 767px) {
      text-align: left;
      font-size: 16px;
    }
  }
  .inner_wrap {
    color: black;
    // padding: 25px 40px;
    padding-top: 0;
    transition: 0.45s;
    max-height: 0;
    overflow: hidden;

    &.show {
      max-height: 1000px;
      padding-top: 40px;
    }
    p {
      font-size: 22px;
      // font-weight: bold;
      margin: 0 auto 20px;
      padding: 0 40px;
      max-width: 800px;

      @media (max-width: 767px) {
        margin: 0 auto 10px;
        font-size: 18px;
        max-width: initial;
        padding: 0;
      }
    }
    @media (max-width: 767px) {
      padding: 0;
      text-align: left;
      font-size: 16px;

      &.show {
        max-height: 1000px;
        padding-top: 12px;
      }
    }

    .result {
      margin-bottom: 10px;
      text-align: left;
      max-width: 720px;
      margin: 0 auto 10px;

      .result_head {
        background: #62ce00;
        font-size: 18px;
        // font-weight: bold;
        color: white;
        padding: 6px 15px;
        line-height: 21px;
        @media (max-width: 767px) {
          padding: 6px 10px;
        }
        &.wrong {
          background: #d2000d;
        }
      }

      .result_body {
        padding: 10px 15px;
        color: black;
        font-size: 20px;
        line-height: 1.4;
        @media (max-width: 767px) {
          padding: 10px;
          line-height: 18px;
        }
      }
    }
  }

  .bottom_section {
    color: white;
    width: 100%;
    padding: 30px;
    background: black;
    margin-top: 40px;
    @media (max-width: 767px) {
      padding: 12px;
      margin-top: 30px;
    }
  }

  .bottom_text {
    max-width: 720px;
    margin: 0 auto 20px;
    p {
      font-size: 24px;
      // font-weight: bold;
    }
  }
}

</style>